import React from 'react';
import {StyleSheet, View} from 'react-native';
import Svg, {Circle, Defs, RadialGradient, Stop} from 'react-native-svg';
import PompiLogo from '../assets/PompiImage.svg';
import {colors} from '../config/theme';

const GLOW_SIZE = 200;
const LOGO_HEIGHT = 134;
const BRAND_TOP = 34; // leaves room for the full glow above the logo

// The Pompi mascot logo on a soft mint bloom, used at the top of the
// password-reset screens.
// glowId: unique gradient id per screen (screens further down the stack
// stay mounted, and SVG ids must not clash on the web).
const AuthBrand = ({glowId = 'authBrandGlow'}) => (
  <View style={styles.brand}>
    <Svg
      width={GLOW_SIZE}
      height={GLOW_SIZE}
      style={styles.glow}
      pointerEvents="none">
      <Defs>
        <RadialGradient id={glowId} cx="50%" cy="50%" r="50%">
          <Stop offset="0" stopColor={colors.primaryFixed} stopOpacity={0.55} />
          <Stop offset="0.6" stopColor={colors.primaryFixed} stopOpacity={0.2} />
          <Stop offset="1" stopColor={colors.primaryFixed} stopOpacity={0} />
        </RadialGradient>
      </Defs>
      <Circle
        cx={GLOW_SIZE / 2}
        cy={GLOW_SIZE / 2}
        r={GLOW_SIZE / 2}
        fill={`url(#${glowId})`}
      />
    </Svg>
    <PompiLogo width={140} height={LOGO_HEIGHT} />
  </View>
);

const styles = StyleSheet.create({
  brand: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: BRAND_TOP,
    paddingBottom: 20,
  },
  // Kept inside the scroll area so the bloom never gets sliced by the header.
  glow: {
    position: 'absolute',
    top: BRAND_TOP + LOGO_HEIGHT / 2 - GLOW_SIZE / 2,
  },
});

export default AuthBrand;
